module.exports = "<div ng-if=vmWizardStep.isActive ng-transclude></div>";


//////////////////
// WEBPACK FOOTER
// ./features/rental/components/rental-checkout-wizard/rental-wizard-step.html
// module id = 649
// module chunks = 0